import styled from 'styled-components'

const Blocks = styled.div`
  > * {
    margin-top: 0 !important;
    margin-bottom: 8rem !important;
  }
`

export default Blocks
